/**
 * Partner companies (installer_partners): outside companies an account works with.
 *
 * EPC: a turnkey company (sells and installs) that sends the account work.
 * INSTALLER: installs work the account sells; the account pays its cost_ppw.
 *
 * The EPC price lives in price_ppw, never cost_ppw: the cost engine reads cost_ppw as money the
 * account pays out, and which way an EPC's money flows is not settled.
 */
export const PARTNER_TYPES = ['EPC', 'INSTALLER'] as const;
export type PartnerType = (typeof PARTNER_TYPES)[number];

export function partnerTypeLabel(type: string | null | undefined): string {
  return type === 'EPC' ? 'EPC' : 'Installer';
}

export function partnerRateField(type: string | null | undefined): 'price_ppw' | 'cost_ppw' {
  return type === 'EPC' ? 'price_ppw' : 'cost_ppw';
}

export function partnerRateLabel(type: string | null | undefined): string {
  return type === 'EPC' ? 'Price per Watt' : 'Cost per Watt';
}

export function partnerManagerLabel(type: string | null | undefined): string {
  return type === 'EPC' ? 'Partner Manager' : 'Installer PM Manager';
}

/** Adder costs feed the cost engine as installer costs, so only installers have them. */
export function partnerHasAdderCosts(type: string | null | undefined): boolean {
  return type !== 'EPC';
}

/** For anything that assigns an installer to a project. A row with no type predates EPCs. */
export function isInstallerPartner(p: { partner_type?: string | null }): boolean {
  return p.partner_type !== 'EPC';
}

export const PARTNER_BADGE_CLASS: Record<PartnerType, string> = {
  EPC: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  INSTALLER: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200',
};

export function partnerFilterChips(partners: { partner_type?: string | null }[]) {
  const epc = partners.filter((p) => p.partner_type === 'EPC').length;
  return [
    { value: 'ALL', label: 'All', count: partners.length },
    { value: 'EPC', label: 'EPC', count: epc },
    { value: 'INSTALLER', label: 'Installer', count: partners.length - epc },
  ];
}
